import React, { useState } from "react"
import { makeStyles, MenuItem, Paper, ClickAwayListener } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  selectorRoot: {
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    position: "relative",
    width: "100%",
    maxWidth: 350,
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
    },
  },
  selectorHeader: {
    backgroundColor: "#fff",
    fontSize: 15,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    padding: "10px 14px",
    borderRadius: 8,
    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
    border: "1px solid #e0e0e0",
    transition: "box-shadow 0.2s",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
    },
  },
  selectorIcon: {
    marginLeft: 8,
    transition: "transform 0.2s",
  },
  dropdown: {
    width: "100%",
    maxHeight: 300,
    overflowY: "auto",
    zIndex: 20,
    position: "absolute",
    top: "110%",
    left: 0,
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 4px 16px rgba(0,0,0,0.13)",
    border: "1px solid #e0e0e0",
  },
  menuItem: {
    fontSize: 15,
    padding: "10px 14px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    wordBreak: "break-all",
  },
  selected: {
    fontWeight: 600,
    color: theme.palette.primary.main,
    background: "#f0f7ff",
  },
}))

/**
 * @param props {{
 *  solFiles: { path: string }[],
 *  selectedFile: string,
 *  setSelectedFile: (path: string) => void
 * }}
 */
export default function FileSelector({ solFiles, selectedFile, setSelectedFile }) {
  const classes = useStyles()
  const [isOpen, setIsOpen] = useState(false)

  const handleSelect = (path) => {
    setSelectedFile(path)
    setIsOpen(false)
  }

  return (
    <div className={classes.selectorRoot}>
      <ClickAwayListener onClickAway={() => setIsOpen(false)}>
        <div>
          <div
            className={classes.selectorHeader}
            onClick={() => setIsOpen((open) => !open)}
            aria-haspopup="listbox"
            aria-expanded={isOpen}
            tabIndex={0}
            style={{ userSelect: "none" }}
          >
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {selectedFile || "Select file"}
            </span>
            <img
              src="/down-black.png"
              height="18"
              alt="Expand"
              className={classes.selectorIcon}
              style={{ transform: isOpen ? "rotate(180deg)" : "none" }}
            />
          </div>
          {isOpen && (
            <Paper className={classes.dropdown} elevation={3}>
              {solFiles && solFiles.length > 0 ? (
                solFiles.map(({ path }) => (
                  <MenuItem
                    key={path}
                    className={`${classes.menuItem} ${selectedFile === path ? classes.selected : ""}`}
                    onClick={() => handleSelect(path)}
                    selected={selectedFile === path}
                  >
                    {path}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled className={classes.menuItem}>
                  No files found
                </MenuItem>
              )}
            </Paper>
          )}
        </div>
      </ClickAwayListener>
    </div>
  )
}